import log from "@/modules/debug";
import environment from "@/modules/environment";
import restartApp from "@/modules/app/restartApp";

window.log = log;
window.isDev = environment.isDev;
window.restartApp = restartApp;
